import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { PricingCards } from './PricingCards';
import { SectionHeading } from './SectionHeading';
import { estudioProRows } from '../data/salesData';
export function OfferSection() {
  return <section id="oferta" className="border-b border-[var(--olive)]/30 py-16 sm:py-20" data-id="element-137" data-mp="ddvhxkufwph7">
      <div className="mx-auto max-w-6xl px-4" data-id="element-138" data-mp="idrl5hvbccvp">
        {/* Launch price / countdown */}
        <div className="mx-auto max-w-2xl rounded-2xl border border-[var(--gold)]/40 bg-[#12140b] p-6 text-center sm:p-8" data-id="element-139" data-mp="mejv6dc0elt1">
          <p className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-[var(--gold)]" data-id="element-140" data-mp="rey37vdm1vr2">
            ⏰ Precio de lanzamiento
          </p>
          <Countdown data-id="element-141" data-mp="wan6o9sr3wsn" />
          <p className="mt-6 flex items-center justify-center gap-2 text-sm text-[var(--gold-light)]" data-id="element-142" data-mp="2t5jaz56c1xuq">
            <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-143" data-mp="2y3ujnckw62bd" />
            Después sube $8.000 ARS. No vuelve.
          </p>
          <div className="mt-6" data-id="element-144" data-mp="12oa6uqljvzh4">
            <div className="mx-auto h-2 max-w-md overflow-hidden rounded-full bg-white/10" data-id="element-145" data-mp="12pl8ajriwv52">
              <div className="h-full w-[68%] rounded-full bg-[var(--gold)]" data-id="element-146" data-mp="xup6irwhiter" />
            </div>
            <p className="mt-2 text-sm text-white/60" data-id="element-147" data-mp="sxyviizjeo07">
              🔴 68% de los cupos al precio de lanzamiento ya tomados
            </p>
          </div>
        </div>

        <SectionHeading className="mt-16" data-id="element-148" data-mp="1ll31orad98dk">Elegí tu Super Kit</SectionHeading>

        <div className="mt-10" data-id="element-149" data-mp="1gmrp48sosjrn">
          <PricingCards data-id="element-150" data-mp="1gnt4uqkndufp" />
        </div>

        {/* Estudio PRO comparison */}
        <div className="mx-auto mt-16 max-w-2xl" data-id="element-151" data-mp="1ckn0xpl0cfce">
          <h3 className="text-center font-serif-display font-bold text-[var(--cream)] sm:text-2xl text-[28px]" data-id="element-152" data-mp="1cnj0tjgf1e3h">
            ¿Qué agrega Estudio PRO?
          </h3>

          <div className="sales-scrollbar mt-6 overflow-x-scroll pb-3" data-id="element-153" data-mp="1842occh0g6s">
            <table className="min-w-[640px] border-separate border-spacing-0 overflow-hidden rounded-2xl border border-[var(--olive)]/40 text-left text-sm w-[640px]" data-id="element-154" data-mp="3scklj1xlg2xq">
              <thead data-id="element-155" data-mp="2nok1sum6dnd">
                <tr className="bg-[#12140b]" data-id="element-156" data-mp="2o81l8gcr00v">
                  <th className="p-4 font-semibold text-[var(--cream)] text-center" data-id="element-157" data-mp="2mwyzbyn7ybc">
                    Situación
                  </th>
                  <th className="p-4 font-semibold text-red-400" data-id="element-158" data-mp="3oumwayp6zx9h">
                    ❌ Sin Estudio PRO
                  </th>
                  <th className="p-4 font-semibold text-[var(--olive-light)]" data-id="element-159" data-mp="3b2gqa5fr76nr">
                    ✅ Con Estudio PRO
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-160" data-mp="315u5thrcahm9">
                {estudioProRows.map((row, i) => <tr key={row.situation} className={i % 2 === 0 ? 'bg-[#0d0f08]' : 'bg-[#0a0b06]'} data-id="element-161" data-mp="313920n7hdrlv" data-mpi={i}>
                    <td className="border-t border-white/5 p-4 font-medium text-[var(--cream)] text-[10px] text-center pl-[15px] pr-[15px] w-[190px] h-[70px]" data-id="element-162" data-mp="362c9sfeuibxj">
                      {row.situation}
                    </td>
                    <td className="border-t border-white/5 p-4 text-white/55 text-[10px] text-center pl-[15px] pr-[15px] w-[190px]" data-id="element-163" data-mp="2dhx8eyyhh5mb">
                      {row.without}
                    </td>
                    <td className="border-t border-white/5 p-4 text-white/80 text-[10px] text-center pl-[15px] pr-[15px] w-[190px]" data-id="element-164" data-mp="2min31zc0cpyg">
                      {row.with}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
}